import { render } from "./PictureStructure.vue?vue&type=template&id=d706abec&scoped=true"
import script from "./PictureStructure.vue?vue&type=script&lang=js"
export * from "./PictureStructure.vue?vue&type=script&lang=js"

import "./PictureStructure.vue?vue&type=style&index=0&id=d706abec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d706abec"]])

export default __exports__